import React from 'react';
import { Popover, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  paper: {}
}));

const RepliconPopover = ({
  id,
  classes: classesOverride,
  anchorEl,
  open,
  onClose,
  verticalAlign = 'top',
  horizontalAlign = 'left',
  children
}) => {
  const popoverClasses = useStyles({ classes: classesOverride });
  const popoverProps = {
    anchorOrigin: { vertical: verticalAlign, horizontal: horizontalAlign },
    transformOrigin: { vertical: verticalAlign, horizontal: horizontalAlign }
  };

  return (
    <Popover
      id={id}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      classes={popoverClasses}
      anchorOrigin={popoverProps.anchorOrigin}
      transformOrigin={popoverProps.transformOrigin}
    >
      {children}
    </Popover>
  );
};

RepliconPopover.propTypes = {
  classes: PropTypes.object,
  id: PropTypes.string.isRequired,
  anchorEl: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  verticalAlign: PropTypes.oneOf(['top', 'bottom']),
  horizontalAlign: PropTypes.oneOf(['left', 'right', 'center']),
  children: PropTypes.node
};

export default RepliconPopover;
